var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4127 27.7374L14.3752 22.9499C16.3377 22.2249 18.1752 21.2499 19.8752 20.1124L16.4127 27.7374ZM7.05019 15.6249L2.2627 13.5874L9.88769 10.1249C8.75019 11.8249 7.77519 13.6624 7.05019 15.6249ZM27.0127 2.98745C27.0127 2.98745 20.8252 0.336199 13.7502 7.41245C11.0127 10.1499 9.3752 13.1624 8.3127 15.7999C7.9627 16.7374 8.20019 17.7624 8.88769 18.4625L11.5502 21.1124C12.2377 21.8124 13.2627 22.0374 14.2002 21.6875C16.8752 20.6624 19.8502 18.9874 22.5877 16.2499C29.6627 9.17495 27.0127 2.98745 27.0127 2.98745ZM18.1752 11.8249C17.2002 10.8499 17.2002 9.26245 18.1752 8.28745C19.1502 7.31245 20.7377 7.31245 21.7127 8.28745C22.6752 9.26245 22.6877 10.8499 21.7127 11.8249C20.7377 12.7999 19.1502 12.7999 18.1752 11.8249ZM11.1002 20.6624L9.33769 18.8999L11.1002 20.6624ZM7.80019 27.4999L12.3502 22.9499C11.9252 22.8375 11.5127 22.6499 11.1377 22.3874L6.03769 27.4999H7.80019ZM2.5002 27.4999H4.2627L10.2252 21.5499L8.4502 19.7874L2.5002 25.7374V27.4999ZM2.5002 23.9624L7.6127 18.8624C7.35019 18.4874 7.16269 18.0874 7.05019 17.6499L2.5002 22.1999V23.9624Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudy);
export default __webpack_public_path__ + "static/media/study.3cae5a354ba8fd04aae78b086e7fb845.svg";
export { ForwardRef as ReactComponent };